import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

import circleGlowPng from '/img/circle-light-effect.png';
import circleGlowWebp from '/img/circle-light-effect.webp';
import lightPng from '/img/light-effect.png';
import lightWebp from '/img/light-effect.webp';
// interface GlowEffectProps extends HTMLAttributes<HTMLDivElement> {
//   className?: string;
// }

const GlowEffect = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    return (
      <div ref={ref} {...props} className={cn(css.wrapper, props.className)}>
        <div
          style={{
            backgroundImage: `image-set("${circleGlowPng}" type("image/png"), "${circleGlowWebp}" type("image/webp"))`,
          }}
          className={css.circleLight}
        ></div>
        <div className={css.yellow}></div>
        <div className={css.green}></div>
        <div
          style={{
            backgroundImage: `image-set("${lightPng}" type("image/png"), "${lightWebp}" type("image/webp"))`,
          }}
          className={css.light}
        ></div>
      </div>
    );
  },
);

export { GlowEffect };
